import { render, staticRenderFns } from "./CreateVip.vue?vue&type=template&id=71cf0b90&scoped=true"
import script from "./CreateVip.vue?vue&type=script&lang=js"
export * from "./CreateVip.vue?vue&type=script&lang=js"
import style0 from "./CreateVip.vue?vue&type=style&index=0&id=71cf0b90&prod&lang=scss&scoped=true"
import style1 from "./CreateVip.vue?vue&type=style&index=1&id=71cf0b90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cf0b90",
  null
  
)

export default component.exports